export namespace OriginId {
  export const Brazil = 1n;
  export const India = 2n;
  export const Mexico = 3n;
  export const Argentina = 4n;
}

export type OriginIdType = (typeof OriginId)[keyof typeof OriginId];
